import { makeStyles } from 'tss-react/mui';

export default makeStyles()({
    container: {
        display: 'flex',
        flexDirection: 'column',
        background: '#FFFFFF',
        padding: '22px',
        boxSizing: 'border-box',
        height: '100%'
    },
    wrapper: {
        flex: 1,
        overflowY: 'auto',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': {
            display: 'none'
        }
    },
    menuList: {
        display: 'flex',
        flexDirection: 'column'
    },
    menuListAdaptive: {
        '@media (max-width: 960px)': {
            alignItems: 'center'
        }
    },
    authButton: {
        marginTop: 16,
        marginBottom: 16,
        marginLeft: 12
    },
    authButtonAdaptive: {
        '@media (max-width: 960px)': {
            marginLeft: 0
        }
    },
    searchBarRoot: {
        width: 300,
        marginBottom: 16
    }
});
